export type CompanyDepartmentOption = {
    id: number;
    name: string;
}

export function CompanyDepartmentOption_normalize(companyDepartmentOption: CompanyDepartmentOption): CompanyDepartmentOption {
    return {
        id: companyDepartmentOption.id ?? 0,
        name: companyDepartmentOption.name ?? ""
    };
}